import { AnimatePresence, cubicBezier, motion } from 'framer-motion';
import { useState } from 'react';
import { useEffect } from 'react';
import { classNames } from '~/utils/classNames';

interface SendButtonProps {
  show: boolean;
  isStreaming?: boolean;
  isDisabled?: boolean;
  promptSubmited?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const customEasingFn = cubicBezier(0.4, 0, 0.2, 1);

export const SendButton: React.FC<SendButtonProps> = ({
  show = false,
  isStreaming = false,
  isDisabled = false,
  promptSubmited = false,
  onClick,
}) => {
  // When streaming, the button should always be enabled (for stopping)
  const actuallyDisabled = isDisabled && !isStreaming;

  const buttonClasses = classNames(
    'flex justify-center items-center top-[90px] right-[22px] p-1 hover:brightness-94 color-white rounded-md w-[34px] h-[34px] transition-theme opacity-100',
    {
      'cursor-not-allowed opacity-50': !show || actuallyDisabled || promptSubmited,
    },
    isStreaming
      ? promptSubmited
        ? 'bg-gradient-to-b from-alpha-primary-start to-alpha-primary-end'
        : 'bg-red-500 hover:bg-red-600'
      : 'bg-gradient-to-b from-alpha-primary-start to-alpha-primary-end',
  );

  const iconClasses = classNames('flex items-center justify-center w-[24px] h-[24px]', {
    'opacity-50': !show || actuallyDisabled || promptSubmited,
  });

  return (
    <AnimatePresence>
      <motion.button
        className={buttonClasses}
        transition={{ ease: customEasingFn, duration: 0.17 }}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        disabled={actuallyDisabled}
        onClick={(event) => {
          event.preventDefault();

          if (actuallyDisabled) {
            return;
          }

          onClick?.(event);
        }}
      >
        <div className={iconClasses}>
          {promptSubmited ? (
            <div className="i-svg-spinners:90-ring"></div>
          ) : !isStreaming ? (
            <div className="i-ph:arrow-right-bold"></div>
          ) : (
            <div className="i-ph:stop-bold"></div>
          )}
        </div>
      </motion.button>
    </AnimatePresence>
  );
};
